import { createContext, useContext, type ReactNode } from 'react';
import { useAuth, type UserRole, type AppRole, type Aal } from './useAuth';
import type { User, Factor } from '@supabase/supabase-js';

interface AuthContextType {
  user: User | null;
  userData: { id: string; role: string; etablissement_id: string | null; prenom: string; nom: string; statut: string } | null;
  role: UserRole;
  appRole: AppRole;
  etablissementId: string | null;
  aal: Aal | null;
  factors: Factor[];
  refreshMfaState: () => Promise<void>;
  loading: boolean;
  signOut: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useAuth();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components -- pattern Provider+hook : useAuthContext est inseparable du Provider (12 fichiers consommateurs). Le warning n'impacte que le HMR de ce fichier.
export function useAuthContext() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuthContext doit etre utilise dans un AuthProvider');
  return ctx;
}
